import { combineReducers } from 'redux';
import userSlice from 'slices/user/userSlice';
import referentialSlice from 'features/referentials/slices/referentialSlice';
import subscriptionProcessSlice from 'features/subscription-process/slices/subscriptionProcessSlice';
import pricingSlice from 'features/subscription-process/pricing-process/slices/pricing/pricingSlice';
import pricingValuesSlice from 'features/subscription-process/pricing-process/slices/pricing-values/pricingValuesSlice';
import genericProfilingSlice from 'features/subscription-process/profiling-process/slices/genericProfilingSlice';
import genericTableSlice from 'slices/generic-table/genericTableSlice';
import abpSlice from 'slices/abp/abpSlice';

const rootReducer = combineReducers({
  abp: abpSlice,
  user: userSlice,
  referential: referentialSlice,

  // Opti slice
  subscriptionProcess: subscriptionProcessSlice,
  pricing: pricingSlice,
  pricingValues: pricingValuesSlice,
  genericProfiling: genericProfilingSlice,

  //TABLE
  tables: genericTableSlice
});

export default (state: any, action: any) =>
  rootReducer(action.type === 'RESET' ? undefined : state, action);
//To-do voir pour ne pas reset le theme
